<div class="row align-content-center text-center g-3">
  <div class="col-md-6">
    <ng-container *ngIf="!media; else preview">
      <div
        class="bg-light py-5 px-3 rounded d-flex align-items-center"
        [style.height]="'180px'">
        <span class="m-0 align-middle">
          Your image preview will show up here
        </span>
      </div>
    </ng-container>
    <ng-template #preview>
      <ng-container *ngIf="media">
        <div class="drop-zone-input-preview" [style.height]="'180px'">
          <img [src]="media.url" [alt]="media.name" class="" />
        </div>
      </ng-container>
    </ng-template>
  </div>
  <div class="col-md-6">
    <ngx-dropzone
      [style.height]="'100%'"
      #dropzone
      [accept]="accept"
      [multiple]="false"
      (change)="prepare($event)">
      <ngx-dropzone-label>
        <p class="mb-2">Drag and Drop your files or</p>
        <a class="btn btn-sm btn-soft-primary"> Upload a Photo </a>
      </ngx-dropzone-label>
    </ngx-dropzone>
  </div>
</div>

<div class="row align-content-center justify-content-center text-center mt-3">
  <div class="col-md-10">
    <p class="mb-2">
      <i class="bx bx-info-circle align-middle font-size-20 text-primary"></i>
      Have an existing image in mind?
    </p>

    <a (click)="library()" class="btn btn-sm btn-soft-primary">
      Open Library
    </a>
  </div>
</div>

<div class="row align-content-center mt-1 required">
  <div class="col">
    <p class="mb-2 text-danger">* Required field</p>
  </div>
</div>
